export class ResearchProgress {
  discipline: string;
  knowledgeLevel: number = 0;
  theoryLevel: number = 0;
  knowledgeProgress: number = 0;
  theoryProgress: number = 0;
}
